import SlantSection from "../Slant/Slant";
import { useStaticQuery, graphql, Link } from "gatsby";
import { Flex } from "theme-ui";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import AccordionButton from "../Accordion/AccordionButton";
import Button from "../Buttons/Button";
import MobileAppButtons from "../Buttons/MobileAppButtons";
interface Props {
  logos: any;
  navOpen: boolean;
  setNavOpen: (open: boolean) => void;
}

export interface NavItemProps {
  route: string;
  path: string;
  external?: boolean;
  children?: {
    route: string;
    path: string;
  }[];
}

const Nav = ({ logos, navOpen, setNavOpen }: Props) => {
  const { refer } = logos;
  const data = useStaticQuery(graphql`
    query NavBlockQuery {
      allDataJson {
        edges {
          node {
            Nav {
              SignUp {
                button1 {
                  text
                  href
                  variant
                }
                inputField {
                  placeholderText
                }
              }
              ReferPromo {
                heading {
                  text
                  color
                }
              }
              routes {
                route
                path
                children {
                  route
                  path
                }
              }
            }
          }
        }
      }
    }
  `);

  const {
    routes,
    ReferPromo: { heading },
    SignUp: {
      inputField: { placeholderText },
      button1,
    },
  } = data.allDataJson.edges[0].node.Nav;
  return (
    <SlantSection
      background="darkBlue"
      variant="right"
      sx={{
        position: ["absolute"],
        right: 0,
        flexDirection: ["column", null, null, "row"],
        justifyContent: ["flex-start", null, null, "space-between"],
        top: [navOpen ? 120 : "-100vh", null, null, navOpen ? 100 : "-100vh"],
        transition: "all .2s ease-in-out",
        pb: [6, 7],
        width: "100%",
        zIndex: navOpen ? 999 : -1,
        opacity: navOpen ? 1 : 0,
        px: [3, null, null, 5],
      }}
    >
      <Flex
        sx={{
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Flex
          sx={{
            flexDirection: ["column", null, null, "row"],
            justifyContent: "space-between",
            alignItems: ["flex-start", null, null, "center"],
            width: "100%",
            maxWidth: 1920,
          }}
        >
          <Flex
            sx={{
              flexDirection: "column",
              width: ["100%", null, 700],
            }}
          >
            {routes.map((r: NavItemProps, i: number) =>
              r.path ? (
                <Link
                  key={i}
                  to={r.path}
                  onClick={() => setNavOpen(false)}
                  sx={{
                    textDecoration: "none",
                  }}
                >
                  <h1
                    sx={{
                      color: "white",
                      fontStyle: "italic",
                      fontSize: [4, null, null, 5, 7],
                      fontWeight: 500,
                      lineHeight: "1.5em",
                      my: 0,
                      p: 0,
                      mx: [2, null, null, 4],
                    }}
                  >
                    {r.route}
                  </h1>
                </Link>
              ) : (
                <div key={i}>
                  <AccordionButton
                    buttonText={r.route}
                    paneContent={
                      <div>
                        {r.children &&
                          r.children.map((rc: NavItemProps, i: number) => (
                            <div
                              key={i}
                              onClick={() => setNavOpen(false)}
                              sx={{
                                my: 1,
                              }}
                            >
                              <Link
                                sx={{
                                  color: "white!important",
                                  fontSize: [
                                    "16px!important",
                                    null,
                                    null,
                                    "18px!important",
                                  ],
                                }}
                                to={rc.path}
                              >
                                {rc.route}
                              </Link>
                            </div>
                          ))}
                      </div>
                    }
                    sx={{
                      width: "fit-content",
                      bg: "darkBlue",
                      p: {
                        variant: "text.h1",
                        textAlign: "left",
                        pr: 3,
                        fontSize: [4, null, null, 5, 7],

                        color: "white",
                        fontStyle: "italic",
                      },
                      ".accordion-pane": {
                        bg: "darkBlue",
                        p: 0,
                        px: 4,
                        div: {
                          p: 0,
                        },
                      },
                    }}
                  />
                </div>
              )
            )}
          </Flex>
          <Flex sx={{ flexDirection: "column", gap: 4, width: "fit-content" }}>
            <Link
              to="/refer-a-friend"
              sx={{
                flexDirection: "column",
                textDecoration: "none",
              }}
            >
              <Flex
                sx={{
                  bg: "#EAF0F4",
                  alignItems: "center",
                  px: 4,
                  py: 4,
                  mt: [4, null, null, 0],
                  borderRadius: 20,
                  flexDirection: ["column", null, "row"],
                }}
              >
                <GatsbyImage
                  image={refer.childImageSharp.gatsbyImageData}
                  alt="Refer a Friend Graphic"
                  sx={{
                    width: [250, null, null, 400],
                  }}
                />
                <h3
                  sx={{
                    color: heading.color,
                    fontSize: [6, null, null, 7],
                    pl: [2, null, 5, 5],
                    my: [1, null, null, 2],
                    textAlign: ["center", null, "left"],
                    maxWidth: 1000,
                    sup: {
                      fontSize: 20,
                    },
                  }}
                  dangerouslySetInnerHTML={{ __html: heading.text }}
                />
              </Flex>
            </Link>
            <div
              sx={{
                flexDirection: "column",
                textDecoration: "none",
              }}
            >
              <Flex
                sx={{
                  bg: "#EAF0F4",
                  alignItems: "center",
                  px: 0,
                  borderRadius: 20,
                  flexDirection: ["column-reverse", null, "row"],
                }}
              >
                <Flex
                  sx={{
                    height: [500, null, 350, 350],
                    width: ["100%", null, "50%", "30%"],
                    overflow: "hidden",
                    justifyContent: "center",
                  }}
                >
                  <StaticImage
                    src="../../images/download-app/downloadAppHero.webp"
                    alt="Lady on app"
                    placeholder="none"
                    sx={{
                      width: [270, null, 300, 250],
                      top: [0, null, null, 0],
                    }}
                  />
                </Flex>
                <Flex
                  sx={{
                    width: ["90%", null, "90%", "70%"],
                    flexDirection: "column",
                    px: 2,
                  }}
                >
                  <h3
                    sx={{
                      color: heading.color,
                      fontSize: [6, null, null, 7],
                      maxWidth: 1000,
                      textAlign: ["center", null, "left"],
                      mb: 4,
                      mt: [3, null, null, 0],
                    }}
                  >
                    Making payments is easier than ever on our new app!
                  </h3>
                  <MobileAppButtons size={200} />
                  <br sx={{ display: ["block", null, null, "none"] }} />
                </Flex>
              </Flex>
            </div>
          </Flex>
        </Flex>
      </Flex>
    </SlantSection>
  );
};

export default Nav;
